import { Notification } from "@mantine/core";

export const NotificationOverwrite = Notification.extend({
  classNames: {
    root: "mapka-notification",
    body: "mapka-notification-body",
    icon: "mapka-notification-icon",
  },
});
